import List from "list.js"; 
// Also only used on one page I think - is it still used at all on .com?
// Used here: https://www.hyland.com/learn/events/partner-series/sessions
// And here: https://www.communitylive.com/en/agenda/session-finder
// As of 9/8/2022
(function($) {

    $(document).ready(function () {
        var $elem = $('select.table-filter');
        
        if ($elem.length > 0) {
            function getIdArray($elem) {
                var idArray = [];
                $elem.each( function() {
                    idArray.push($(this).attr('id'))
                })
                
                return idArray;
            }
            
            // Classes
            var options = {
                valueNames: getIdArray($elem)
            };

            var featureList = new List('table-filter', options);

            var selection = {};
            options.valueNames.forEach( function(valueName) {
                $('#' + valueName).change(function () {
                    // If a value atteribute isn't provided set it to "" (for none/all selection)
                    if (!$(this).find(':selected').is("[value]")) { 
                        selection[valueName] = "";
                    } else {
                        selection[valueName] = this.value;
                    }
                })
            })

            $elem.change(function () {
                featureList.filter( function (item) {

                    let isMatch = true;
                    for (const key in selection) {
                        if (isMatch) {
                            isMatch = item.values()[key].includes(selection[key])

                            // If selection is 'none/all' then reset filter
                            if (selection[key] == '') {
                                isMatch = true
                            }
                        }
                    }
                    return isMatch;

                })

            })
        }
    });
    
})(jQuery);
